/**
 * Page header component that handles responsive behavior and scroll-based visibility
 *
 * @class PageHeader
 */
class PageHeader {
    /**
     * Creates an instance of PageHeader
     *
     * @param {HTMLElement} elem - The page header DOM element
     */
    constructor(elem) {
        this.pageHeader = elem;
        // this.breakpoint = parseInt(getComputedStyle(this.pageHeader)
        // .getPropertyValue('--main-navigation-breakpoint'), 10);
        this.breakpoint = 0;
        this.lastScrollPosition = 0;
        // Set threshold to 75% of viewport height
        this.scrollThreshold = window.innerHeight * 0.75;
        this.hasScrolled = false;
    }

    /**
     * Initializes the page header component
     * Sets up event listeners for scroll and resize events based on viewport width
     */
    init = () => {
        // Initialize scroll behavior only above breakpoint
        if (window.innerWidth >= this.breakpoint) {
            this.addScrollListener();
        }

        // Handle responsive behavior
        window.addEventListener('resize', () => {
            if (window.innerWidth >= this.breakpoint) {
                this.addScrollListener();
            } else {
                this.removeScrollListener();
                // this.pageHeader.classList.remove('page-header--visible');
            }
        });
    };

    /**
     * Handles scroll events to show/hide the header based on scroll direction and position
     * Shows header when scrolling up or when near the top of the page
     * Hides header when scrolling down past the threshold
     */
    handleScroll = () => {
        if (!this.hasScrolled) {
            this.hasScrolled = true;
            return;
        }

        const currentScrollPosition = window.pageYOffset;

        // Toggle header visibility based on scroll direction and threshold
        if (currentScrollPosition > this.scrollThreshold) {
            if (currentScrollPosition > this.lastScrollPosition) {
                this.pageHeader.classList.remove('page-header--visible');
            } else if (currentScrollPosition < this.lastScrollPosition) {
                this.pageHeader.classList.add('page-header--visible');
            }
        } else {
            this.pageHeader.classList.add('page-header--visible');
        }

        this.lastScrollPosition = currentScrollPosition;
    };

    /**
     * Adds the scroll event listener to the window
     */
    addScrollListener = () => {
        window.addEventListener('scroll', this.handleScroll);
    };

    /**
     * Removes the scroll event listener from the window
     */
    removeScrollListener = () => {
        window.removeEventListener('scroll', this.handleScroll);
    };
}

export default PageHeader;
